import { useQuery } from '@tanstack/react-query';
import { getMetricsData, getFacilityFilter } from '../services/metricsService';

export const useGetMetricsData = () => {
  const { data, isLoading, isError, error, refetch, isPending } = useQuery({
    queryKey: ['metricsData'],
    staleTime: 0,
    gcTime: 0,
    queryFn: async () => {
      const data = await getMetricsData();
      return data;
    },
  });
  return {
    metricsData: data,
    isLoading,
    isError,
    error,
    isPending,
    refetch,
  };
};
export const useGetFacilityFilterMetrics = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['facilityFilter'],
    queryFn: async () => {
      const data = await getFacilityFilter();
      return data;
    },
  });
  return {
    facilityFilter: data,
    isLoading,
    isError,
    error,
  };
};
